import React from 'react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';

/**
 * RTL Cache for Emotion
 *
 * Configures emotion to properly handle RTL (Right-to-Left) CSS transformations
 * for Hebrew text. This ensures that CSS properties like margin, padding, border,
 * and positioning are correctly flipped for RTL layout.
 *
 * Without this, MUI's direction: 'rtl' theme setting alone is insufficient.
 */
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

interface RTLProps {
  children: React.ReactNode;
}

/**
 * RTL Provider Component
 *
 * Wraps the app to enable proper RTL CSS transformations for Material-UI
 * components and styled-components.
 *
 * @example
 * <RTL>
 *   <ThemeProvider theme={theme}>
 *     <App />
 *   </ThemeProvider>
 * </RTL>
 */
export function RTL({ children }: RTLProps) {
  return <CacheProvider value={cacheRtl}>{children}</CacheProvider>;
}
